import React, { useEffect, useState } from 'react';

import { useAccount } from 'wagmi';

import { useGlobalContext } from '../../AppContext';
import { DashboardMainLink } from '../DashboardMainLink';

import './BigMenu.scss';

interface BigMenuProps {
  horizontal?: boolean;
}
export const BigMenu = ({ horizontal = false }: BigMenuProps) => {
  const { config, portfolioStatus, customSearch, demoMode, isMobile, vestingCalendars } =
    useGlobalContext();
  const { address: account } = useAccount();
  const [menuItems, setMenuItems] = useState<any>();

  useEffect(() => {
    console.log('NFT Icon: ', !demoMode && (!config || (config && !config.nftLoaded)));
    if ((config && config.pnl) || demoMode) {
      if (horizontal) {
        if (
          isMobile &&
          document &&
          document.location &&
          (document.location.pathname === '/settings' || document.location.pathname === '/profile')
        ) {
          setMenuItems([
            {
              longText: false,
              reverse: true,
              name: 'Portfolio',
              disabled: false,
              image: `menu/my-portfolio-${portfolioStatus}.png`,
              link: '/my-portfolio',
            },
            {
              longText: false,
              reverse: true,
              name: 'NFT & ENS',
              disabled: !demoMode && (!config || (config && !config.nftLoaded)),
              image: 'menu/nft.png',
              link: '/nft-ens',
            },
            {
              longText: false,
              reverse: false,
              name: 'Whales',
              disabled: !account || customSearch || (!demoMode && !config),
              image: 'menu/whales.png',
              link: '/whales',
            },
            {
              longText: false,
              reverse: false,
              name: 'Buy & Sell',
              disabled: false,
              image: 'menu/buysell.png',
              link: '/buy-sell',
            },
            {
              longText: false,
              reverse: false,
              name: 'Favorites',
              disabled: !demoMode && (!account || customSearch),
              image: 'menu/favorites.png',
              link: '/favorites',
            },
            {
              longText: true,
              reverse: true,
              name: 'VestingCal',
              disabled: !demoMode && !config,
              image: 'menu/vesting-calendar.png',
              link: '/vesting-calendar',
            },
            {
              longText: false,
              reverse: false,
              name: 'Stats',
              disabled: false,
              image: 'menu/statistics.png',
              link: '/statistics-fees',
            },
            {
              longText: false,
              reverse: false,
              name: 'Alerts',
              disabled: !demoMode && (!account || customSearch),
              image: 'menu/reminders.png',
              link: '/reminders',
            },
          ]);
        } else {
          setMenuItems([
            {
              longText: false,
              reverse: false,
              name: 'Home',
              disabled: false,
              image: 'menu/dashboard.png',
              link: '/',
            },
            {
              longText: false,
              reverse: true,
              name: 'Portfolio',
              disabled: false,
              image: `menu/my-portfolio-${portfolioStatus}.png`,
              link: '/my-portfolio',
            },
            {
              longText: false,
              reverse: true,
              name: 'NFT & ENS',
              disabled: !demoMode && (!config || (config && !config.nftLoaded)),
              image: 'menu/nft.png',
              link: '/nft-ens',
            },
            {
              longText: false,
              reverse: false,
              name: 'Whales',
              disabled: !demoMode && (!account || customSearch),
              image: 'menu/whales.png',
              link: '/whales',
            },
            {
              longText: false,
              reverse: false,
              name: 'Buy & Sell',
              disabled: false,
              image: 'menu/buysell.png',
              link: '/buy-sell',
            },
            {
              longText: false,
              reverse: false,
              name: 'Favorites',
              disabled: !demoMode && (!account || customSearch),
              image: 'menu/favorites.png',
              link: '/favorites',
            },
            {
              longText: true,
              reverse: true,
              name: 'VestingCal',
              disabled: !demoMode && !config,
              image: 'menu/vesting-calendar.png',
              link: '/vesting-calendar',
            },
            {
              longText: false,
              reverse: false,
              name: 'Stats',
              disabled: false,
              image: 'menu/statistics.png',
              link: '/statistics-fees',
            },
            {
              longText: false,
              reverse: false,
              name: 'Alerts',
              disabled: !demoMode && (!account || customSearch),
              image: 'menu/reminders.png',
              link: '/reminders',
            },
          ]);
        }
      } else {
        setMenuItems([
          {
            longText: false,
            reverse: true,
            name: 'Portfolio',
            disabled: false,
            image: `menu/my-portfolio-${portfolioStatus}.png`,
            link: '/my-portfolio',
          },
          {
            longText: false,
            reverse: true,
            name: 'NFT & ENS',
            disabled: !demoMode && (!config || (config && !config.nftLoaded)),
            image: 'menu/nft.png',
            link: '/nft-ens',
          },
          {
            longText: false,
            reverse: false,
            name: 'Whales',
            disabled: !demoMode && (!account || customSearch),
            image: 'menu/whales.png',
            link: '/whales',
          },
          {
            longText: false,
            reverse: false,
            name: 'Buy & Sell',
            disabled: false,
            image: 'menu/buysell.png',
            link: '/buy-sell',
          },
          {
            longText: false,
            reverse: false,
            name: 'Favorites',
            disabled: !demoMode && (!account || customSearch),
            image: 'menu/favorites.png',
            link: '/favorites',
          },
          {
            longText: true,
            reverse: true,
            name: 'VestingCal',
            disabled: false,
            image: 'menu/vesting-calendar.png',
            link: '/vesting-calendar',
          },
          {
            longText: false,
            reverse: false,
            name: 'Stats',
            disabled: false,
            image: 'menu/statistics.png',
            link: '/statistics-fees',
          },
          {
            longText: false,
            reverse: false,
            name: 'Alerts',
            disabled: !demoMode && (!account || customSearch),
            image: 'menu/reminders.png',
            link: '/reminders',
          },
        ]);
      }
    }
  }, [config, vestingCalendars, demoMode]);

  return (
    <div
      className={`big-menu main-links ${
        horizontal && innerWidth > 1025 ? 'horizontal' : 'default'
      }`}
    >
      {menuItems &&
        menuItems.map((item: any, index: number) => {
          if (
            (!(
              document.location.pathname === '/settings' &&
              document.location.pathname === '/profile' &&
              item.link === '/statistics-fees'
            ) &&
              document.location.pathname !== item.link) ||
            innerWidth > 1025
          ) {
            return (
              <DashboardMainLink
                key={index}
                id={`link-${index}`}
                active={document.location.pathname === item.link ? true : false}
                disabled={item.disabled}
                name={item.name}
                image={item.image}
                link={item.link}
                reverse={item.reverse}
                longText={item.longText}
                demoMode={demoMode}
              />
            );
          }
        })}
    </div>
  );
};
